var map = {
	"./configuration.ts": 50496,
	"./init.conf.ts": 61392,
	"./plugins/jquery.infoPage.ts": 80238,
	"./plugins/jquery.lastModifiedCheck.ts": 36648,
	"./plugins/jquery.lightbox.ts": 37636,
	"./selectorConfiguration.ts": 16223,
	"legacy/customer/allianz/configuration.ts": 50496,
	"legacy/customer/allianz/init.conf.ts": 61392,
	"legacy/customer/allianz/plugins/jquery.infoPage.ts": 80238,
	"legacy/customer/allianz/plugins/jquery.lastModifiedCheck.ts": 36648,
	"legacy/customer/allianz/plugins/jquery.lightbox.ts": 37636,
	"legacy/customer/allianz/selectorConfiguration.ts": 16223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40005;